import { api } from './client';

import type { HelpArticleListItem } from './help';

/** ч.1009, Етап 3: звернення до підтримки. */
export type CaseStatus =
  | 'NEW' | 'IN_PROGRESS' | 'WAITING_USER'
  | 'ESCALATED' | 'RESOLVED' | 'CLOSED';

export interface SupportMessage {
  id: string;
  author_kind: 'user' | 'agent' | 'staff';
  author_name: string | null;
  body: string;
  created_at: string;
  /** ч.1012: лише ознака — сам знімок тягнеться окремо, за кліком. */
  has_screenshot: boolean;
}

export interface SupportCaseListItem {
  id: string;
  public_id: string;
  title: string;
  status: CaseStatus;
  category: string | null;
  route_pattern: string | null;
  last_message_at: string;
  /** ч.1241: скільки відповідей підтримки користувач ще не читав. */
  unread?: number;
}

export interface SupportCase extends SupportCaseListItem {
  messages: SupportMessage[];
  /** Підказані статті — показуються окремою рамкою вгорі переписки. */
  suggested: HelpArticleListItem[];
}

export interface CaseCreateIn {
  title: string;
  body: string;
  route_pattern?: string | null;
  organization_id?: string | null;
  /** Знімок екрана як data-URL (PNG). */
  screenshot?: string | null;
}

export const support = {
  cases: () =>
    api.get<SupportCaseListItem[]>('/support/cases').then((r) => r.data),

  /** ч.1241: непрочитані відповіді — позначка на кнопці підтримки. */
  unread: () =>
    api.get<{ count: number; cases: number }>('/support/unread',
      { headers: { 'X-Silent-Toast': '1' } }).then((r) => r.data),

  case: (id: string) =>
    api.get<SupportCase>(`/support/cases/${id}`).then((r) => r.data),

  create: (payload: CaseCreateIn) =>
    api.post<SupportCase>('/support/cases', payload).then((r) => r.data),

  reply: (id: string, body: string, screenshot?: string | null) =>
    api.post<SupportCase>(`/support/cases/${id}/messages`, { body, screenshot })
      .then((r) => r.data),

  screenshot: (messageId: string) =>
    api.get<{ content: string }>(`/support/messages/${messageId}/screenshot`)
      .then((r) => r.data.content),

  close: (id: string, rating?: number) =>
    api.post<SupportCase>(`/support/cases/${id}/close`,
      null, { params: rating ? { rating } : {} }).then((r) => r.data),
};

export default support;
